/**
 * The sort code and account number the Approvals page shows for a pending bank-details
 * row, and the ones it sends when Credit approves it.
 *
 * Approval is tied to the digits Credit reviewed, so the cells and the request body come
 * from this one function: what is rendered cannot drift from what is compared. It never
 * falls back to the row's raw `sort_code`/`account_number`, which the page does not show,
 * and a missing value is `""` rather than `undefined` so the key stays in the JSON (an
 * absent one is answered with a 422 whose list-shaped `detail` the toast cannot render).
 * A masked value is sent as shown and the server refuses it.
 */
export const reviewedBankDigits = (item) => ({
  sort_code: item.full_sort_code || item.masked_sort_code || "",
  account_number: item.full_account_number || item.masked_account || "",
});
